enum PublishStatus {
    Published = 0,
    Unpublished = 1,
    PublishedWithUnpublishedChanges = 2,
}

export default PublishStatus;
